import { FC } from 'react'
import { IconPaths, ModalSize } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { RowActions, useModal } from 'app/components'
import { SncrNumerosUsadosModal } from '../../../components/SncrNumerosUsadosModal'
import { SncrBloco, numerosUsadosDoBloco } from '../../../core/_models'

type IProps = {
  bloco: SncrBloco
}

/** Única ação do bloco: ver em quais receitas os números já consumidos foram usados. */
export const SncrBlocoActionsCell: FC<IProps> = ({ bloco }) => {
  const { t } = useT()
  const { showModal } = useModal()

  // Sem consumo não há o que ver.
  if (numerosUsadosDoBloco(bloco) === 0) return null

  const abrirUsados = () =>
    showModal({
      title: t('sncr.numeros.titulo', { inicio: bloco.numeroInicio, fim: bloco.numeroFim }),
      size: ModalSize.Large,
      content: <SncrNumerosUsadosModal bloco={bloco} />,
    })

  return (
    <RowActions
      itemName={t('sncr.lista.item_nome', { inicio: bloco.numeroInicio })}
      primaryAction={{
        label: t('sncr.lista.ver_usados'),
        icon: IconPaths.Search,
        onClick: abrirUsados,
      }}
    />
  )
}
